import { cn } from '../../lib/utils';

/**
 * The selection dot used by the offer tables — quantity tiers, shipping methods,
 * combination plans.
 *
 * Presentational only: every caller already has a clickable row, tab or pill
 * wrapping it, so this renders no button and takes no click of its own.
 *
 * Whole pixels throughout: a fractional dot inside a fractional ring
 * sizes land on fractions like 11.2px — and a 4.8px dot inside an 11.2px ring
 * antialiases unevenly, which reads as off-centre however it's positioned. At
 * 12/4 with a 1px ring every edge is on a device pixel and the 3px gap is even
 * on all sides.
 */
interface RadioProps {
	checked: boolean;
	/** Dims the ring, for an option that can't be picked. */
	muted?: boolean;
	className?: string;
}

export function Radio({ checked, muted = false, className }: RadioProps) {
	return (
		<span
			aria-hidden
			className={cn(
				'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full',
				className
			)}
			style={{
				boxShadow: `inset 0 0 0 1px ${
					checked ? 'var(--accent)' : muted ? 'var(--line-2)' : 'var(--line-3)'
				}`,
			}}
		>
			{checked && <span className="h-1.5 w-1.5 rounded-full bg-accent" />}
		</span>
	);
}
